<div class="flex flex-col">
    <div class="flex flex-col-reverse w-full relative">
        <input
            sag-ui-input
            type="text"
            style="padding-right: 40px"
            [id]="id"
            [disabled]="disabled"
            [placeholder]="floatLabel ? '' : placeholder"
            [required]="invalid || (required && touched)"
            [attr.pattern]="invalid ? 'SAG_INVALID_STATE' : null"
            [attr.data-float-label]="floatLabel"
            [value]="displayValue"
            (input)="blockChange($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            #input
        />
        <label
            sag-ui-input-label
            [htmlFor]="id"
            [attr.data-float]="floatLabel ? focused || !!value : undefined"
            [attr.data-float-label]="floatLabel"
        >
            <span *ngIf="required">*</span>
            {{ label }}
            <span
                *ngIf="hint"
                class="text-[#999999] dark:text-[#666666] icon-circle-information pl-2"
                sag-ui-tooltip
                [tooltip]="hint"
            ></span>
        </label>
        <span
            class="absolute right-5 bottom-[0.8rem] z-10 text-black dark:text-white"
            (click)="!disabled && togglePopover($event)"
            [class.icon-chevron-up]="isOpen"
            [class.icon-chevron-down]="!isOpen"
            [class.opacity-50]="disabled"
        ></span>
        <div
            [class]="popoverClasses"
            [class.hidden]="!isOpen"
            [class.top-full]="!isDropdownUpwards"
            [class.bottom-input]="isDropdownUpwards"
        >
            <div class="relative w-full h-full">
                <div *ngIf="search" [class]="searchClasses">
                    <sag-ui-checkbox [checked]="allSelected" (change)="handleSelectAll()" *ngIf="multiple">
                        {{ selectAllText }}
                    </sag-ui-checkbox>
                    <input
                        type="text"
                        [placeholder]="searchPlaceholder"
                        [class]="searchInputClasses"
                        (input)="handleSearch($event)"
                    />
                </div>
                <ng-content select="sag-ui-option" (click)="handleItemClick($event)"></ng-content>
            </div>
        </div>
    </div>
    <div *ngIf="error && isArray(error)" class="flex flex-col gap-1">
        <span sag-ui-input-error *ngFor="let err of error">{{ err }}</span>
    </div>
    <span sag-ui-input-error *ngIf="error && !isArray(error)">{{ error }}</span>
</div>
